<!-- THIS COMPONENT IS CURRENTLY UNUSED, WAS FORMERLY USED IN THE ConversionOptionScreen-vue !-->
<!-- If this component needs to be re-used, please take actions when neccessary!-->
<template>
  <v-card class="path-selection">
    <v-card-title class="ps-title" primary-title> Offene Fragen klären </v-card-title>
    <div class="ps-content">
      <v-img
        contain
        class="ps-img"
        height="50px"
        max-width="168px"
        src="../../assets/helpIcon250px.png"
      >
      </v-img>
      <v-card-text class="ps-text">
        Sie haben eine Frage zu Ihren gemerkten Hilfsmitteln oder zur Kostenübernahme?<br>Wir helfen Ihnen gerne weiter!
      </v-card-text>
    </div>
    <v-card-actions class="ps-card-actions">
      <v-btn depressed @click="showHelpModal" class="primary-btn"><div class="btn-text">Fragen klären</div></v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  methods: {
    showHelpModal(){
      this.$emit("showHelpModal")
    }
  },
};
</script>

<style>
</style>